import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAtom, atom } from 'jotai'

const userNameAtom = atom(localStorage.getItem("userName") ? localStorage.getItem("userName") : null);
const companyNameAtom = atom(localStorage.getItem("companyName") ? localStorage.getItem("companyName") : null);
const divisionNameAtom = atom(localStorage.getItem("affiliation") ? localStorage.getItem("affiliation") : null);
const secretInfoAtom = atom(null);
const personalInfoAtom = atom(null);
const checkBoxAtom = atom(false);

function MainComponent() {

    document.title = "添付ファイル 管理情報入力| ファーストコンタクトセンター";
    const imageUrlPopUp = require("../../images/popup.png")
    const location = useLocation();
    const [userName, setUserName] = useAtom(userNameAtom);
    const [companyName, setCompanyName] = useAtom(companyNameAtom);
    const [divisionName, setDivisionName] = useAtom(divisionNameAtom);
    const [secretInfo, setSecretInfo] = useAtom(secretInfoAtom);
    const [personalInfo, setPersonalInfo] = useAtom(personalInfoAtom);
    const [checkBox, setCheckBox] = useAtom(checkBoxAtom);
    const navigate = useNavigate();
    const caseId = location.state.next_state.caseId;
    const contactId = location.state.next_state.contactId;
    const nameCheck = ["", undefined, null, false];

    function initInput() {
        setUserName(nameCheck.includes(location.state.next_state.userName) ? localStorage.getItem("userName") : location.state.next_state.userName);
        setCompanyName(nameCheck.includes(location.state.next_state.companyName) ? localStorage.getItem("companyName") : location.state.next_state.companyName);
        setDivisionName(nameCheck.includes(location.state.next_state.divisionName) ? localStorage.getItem("affiliation") : location.state.next_state.divisionName);
        setSecretInfo(location.state.next_state.secretInfo);
        setPersonalInfo(location.state.next_state.personalInfo);
        setCheckBox(false);
        location.state.page = false
    }
    if (!location.state) {
        location.state = { page: false };
    }
    if (location.state.page === true) {
        initInput()
    }

    const handleCheckBoxChange = (event) => {
        setCheckBox(event.target.checked);
    }

    const onClickSend = () => {

        let newUserName = userName.replace(/^\s+/g, '');
        let newCompanyName = companyName.replace(/^\s+/g, '');
        let newDivisionName = divisionName.replace(/^\s+/g, '');
        if (nameCheck.includes(newUserName)) {
            alert("登録者名を入力してください。");
            return;
        }
        if (nameCheck.includes(newCompanyName)) {
            alert("会社名/団体名を入力してください。");
            return;
        }
        if (nameCheck.includes(newDivisionName)) {
            alert("所属を入力してください。");
            return;
        }
        if (nameCheck.includes(secretInfo)) {
            alert("秘密情報の有無にチェックしてください。");
            return;
        }
        if (nameCheck.includes(personalInfo)) {
            alert("個人情報の有無にチェックしてください。");
            return;
        }
        if (personalInfo === 1) {
            if (checkBox === false) {
                alert("個人情報の収集の承諾にチェックをしてください。");
                return;
            }
        }
        var next_state = {
            userName: userName ? userName.trim() : userName,
            companyName: companyName ? companyName.trim() : companyName,
            divisionName: divisionName ? divisionName.trim() : divisionName,
            secretInfo: secretInfo,
            personalInfo: personalInfo,
            caseId: caseId,
            contactId: contactId,
        };
        navigate("/file_info_confirm", { state: next_state });
        setCheckBox(false);
    }

    return (
        <div className="ls-row str-column-main" id="ls-row-3-col-1-row-2-col-2-row-1">
            <div className="str-outer">
                <div className="str-inner">
                    <div className="mod-hdg-l1">
                        <div className="inner">
                            <h1 className="hdg">Web問い合わせシステム</h1>
                            <span className="sub of-top">NEC ファーストコンタクトセンター</span>
                        </div>
                    </div>
                    <h2 className="mod-hdg-l2-02">
                        <span>添付ファイル 管理情報入力</span>
                    </h2>
                    <input type="hidden" name="inquiry_no" defaultValue="1210987" />
                    <h4 className="mod-hdg-l4-02">
                        基本情報
                    </h4>

                    <div className="mod-tbl-form">
                        <table role="presentation">
                            <colgroup>
                                <col className="w-35" />
                                <col />
                            </colgroup>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>登録者名<span className="required">必須</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="mod-input">
                                            <input value={userName ? userName : ""} onChange={(e) => setUserName(e.target.value)} type="text" id="user" name="user" maxLength="128" style={{ maxWidth: '70%' }}
                                                placeholder="例：日電太郎" />
                                        </div>

                                    </td>
                                </tr>
                            </tbody>


                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>会社名/団体名<span className="required">必須</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="mod-input">
                                            <input value={companyName ? companyName : ""} onChange={(e) => setCompanyName(e.target.value)} type="text" id="company" name="company" maxLength="128" style={{ maxWidth: "70%" }}
                                                placeholder="例：○○○○会社" />
                                        </div>

                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>所属<span className="required">必須</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="mod-input">
                                            <input value={divisionName ? divisionName : ""} onChange={(e) => setDivisionName(e.target.value)} type="text" id="division" name="division" maxLength="128" style={{ maxWidth: "70%" }}
                                                placeholder="例：○○○○事業部" />
                                        </div>

                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">秘密情報の有無<span className="required">必須</span></span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="mod-input-radio">
                                            <ul className="list">
                                                <li>
                                                    <label>
                                                        <input type="radio" id="secret_info1" name="secret_info" value="1" checked={secretInfo === 1}
                                                            onChange={() => setSecretInfo(1)} />
                                                        <span className="label">有</span>
                                                    </label>
                                                </li>
                                                <li>
                                                    <label>
                                                        <input type="radio" id="secret_info2" name="secret_info" value="0" checked={secretInfo === 0}
                                                            onChange={() => setSecretInfo(0)} />
                                                        <span className="label">無</span>
                                                    </label>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">個人情報の有無<span className="required">必須</span></span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="mod-input-radio">
                                            <ul className="list">
                                                <li>
                                                    <label>
                                                        <input type="radio" id="personal_info1" name="personal_info" value="1" checked={personalInfo === 1}
                                                            onChange={(e) => setPersonalInfo(1)} />
                                                        <span className="label">有</span>
                                                    </label>
                                                </li>
                                                <li>
                                                    <label>
                                                        <input type="radio" id="personal_info2" name="personal_info" defaultValue="0" checked={personalInfo === 0}
                                                            onChange={(e) => { setPersonalInfo(0); setCheckBox(false) }} />
                                                        <span className="label">無</span>
                                                    </label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div>
                                            個人情報が含まれる場合は、<img src={imageUrlPopUp} alt="new window" /> <Link to="/handle_personal_info" target="_blank" rel="noreferrer" >「個人情報の取扱いについて」</Link>に記載しておりますので、ご確認および承諾の上、以下にチェックしてください。
                                        </div>
                                        <div className="mod-input-check" style={{ marginTop: "15px" }}>
                                            <ul className="list">
                                                <li><label>
                                                    <input disabled={personalInfo === 0 ? true : false} type="checkbox" id="mynumber" name="mynumber" checked={checkBox === true} onChange={handleCheckBoxChange} />
                                                    <span className="label">個人情報の収集について承諾する。</span>
                                                </label></li>
                                            </ul>
                                        </div>
                                    </td>

                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>お預かり情報</b>
                                        </div>
                                    </td>
                                    <td>
                                        <p>電子データ</p>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>消去方法</b>
                                        </div>
                                    </td>
                                    <td>
                                        <p>消去</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="mod-btn of-list" style={{ marginTop: "20px" }}>
                        <div className="btn">
                            <button id="btn-send" className="btn_default_select" onClick={onClickSend}>登録内容で送信する</button>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default MainComponent;